import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import { ALERT_TYPE_CODE } from '../constant'
import classes from './index.module.scss'

export const FilingStatus = ({ data, detailKey }) => {
  const detailData = data[detailKey]

  const getContent = () => {
    switch (data.alertTypeCode) {
      case ALERT_TYPE_CODE.UPDATETAX.key:
        return 'alertDetail.OVERDUE_TAXT_DEBT_CONTENT'
      case ALERT_TYPE_CODE.UPDATEINSURANCE.key:
        return 'alertDetail.OVERDUE_SOCIAL_INSURANCE_CONTENT'
      case ALERT_TYPE_CODE.UPDATEINVOICE.key:
        return 'alertDetail.INVOICE_ENFORCEMENT_CONTENT'
      default:
        return ''
    }
  }

  const getView = () => {
    switch (data.alertTypeCode) {
      case ALERT_TYPE_CODE.UPDATETAX.key:
        return 'alertDetail.OVERDUE_TAXT_DEBT_VIEW'
      case ALERT_TYPE_CODE.UPDATEINSURANCE.key:
        return 'alertDetail.OVERDUE_SOCIAL_INSURANCE_VIEW'
      case ALERT_TYPE_CODE.UPDATEINVOICE.key:
        return 'alertDetail.INVOICE_ENFORCEMENT_VIEW'
      default:
        return ''
    }
  }

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element className={classes.content} style={{ color: '#3A414B' }}>
        <div>
          <Translate value={getContent()} dangerousHTML />
        </div>
        <div>
          <Element elementName="span" style={{ color: '#2C73E8' }}>
            <Link
              to={`${COMPONENTS.companyAnalysis.components.filingStatus.route}?organizationId=${data?.organizationId}`}
              target="_blank"
            >
              <Translate value="alertDetail.CLICK_HERE" />
            </Link>
          </Element>
          &nbsp;
          <Translate value={getView()} />
        </div>
      </Element>
    </Panel>
  )
}
